import React from "react";
import {BsCaretRightFill} from "react-icons/bs"
export default () => (
    <div style={{textAlign: "center"}}>
        <BsCaretRightFill/>
    </div>
)